export default __webpack_public_path__ + "static/b2-fc980f577f999e3a1d797559767873f0.jpg";